module.exports = __webpack_public_path__ + "static/template_list_multiple_years-7cd4b8de20fcde16fd0b5e8de9e4bf26.png";